export default __webpack_public_path__ + "c390dfeff4066651be3cc358ce03a373.png";